import { EventEmitter } from "events";

const socketEmitter = new EventEmitter();

export default socketEmitter;
